import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import "../sentry.config.ts";
import "../contentsquare.config.ts";

import App from "./App.tsx";
import { AppWrapper } from "./components/common/PageMeta.tsx";
// import { ThemeProvider } from "./context/ThemeContext.tsx";
import { StateProvider } from "./context/StateValueContext";
import reducer, { initialState } from "./reducer.js";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";
import * as Sentry from "@sentry/react";
import ErrorFallback from "./components/common/ErrorFallback.tsx";

dayjs.extend(utc);
dayjs.extend(timezone);

const theme = createTheme({
  palette: {
    primary: { main: '#465fff', dark: '#3641f5' },
  },
  typography: {
    fontFamily: [
      '"Outfit"',
      '"Roboto"',
      '"Helvetica"',
      '"Arial"',
      'sans-serif',
    ].join(','),
  },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Sentry.ErrorBoundary
      fallback={<ErrorFallback />}
    >
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <AppWrapper>
          <StateProvider initialState={initialState} reducer={reducer}>
            <App />
          </StateProvider>
        </AppWrapper>
      </ThemeProvider>
    </Sentry.ErrorBoundary>
  </StrictMode>
);
